
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.224 8.459a2.011 2.011 0 00-2.002 2.007v1.566h-3.51a2.025 2.025 0 00-2.025 2.014v5.335c0 1.112.913 2.024 2.024 2.024h14.583a2.03 2.03 0 002.02-2.024v-3.365c0-1.11-.909-2.021-2.02-2.021h-3.562l-.028-3.534c-.014-1.097-.91-2.002-2.007-2.002H8.224zm0 1.126h3.473c.497 0 .872.383.882.886l.08 9.81H7.342v-9.815c0-.498.384-.88.881-.88zm-5.513 3.572h3.511v7.124h-3.51a.888.888 0 01-.9-.9v-5.335c0-.501.393-.89.9-.89zm11.03 1.963h3.553c.507 0 .9.395.9.896v3.365c0 .506-.393.9-.9.9h-3.51l-.043-5.161zM9.907.59a.563.563 0 00-.504.318L8.6 2.563l-1.818.276a.563.563 0 00-.306.96L7.8 5.077 7.5 6.89a.563.563 0 00.82.588l1.624-.866 1.633.846a.563.563 0 00.813-.597l-.322-1.812 1.31-1.293a.563.563 0 00-.318-.957l-1.823-.253L10.413.9a.562.562 0 00-.506-.31zm.01 1.835l.447.89a.563.563 0 00.425.305l.987.137-.71.7a.563.563 0 00-.159.5l.176.979-.884-.457a.562.562 0 00-.525.003l-.878.468.163-.983a.562.562 0 00-.165-.496l-.718-.691.985-.149a.562.562 0 00.422-.31l.434-.896z","fill":"#fff"}})])
          )
        }
      }
    